module.exports = __webpack_public_path__ + "static/img/head.53c76809.png";